var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Subject } from '@/models/Subject';
import { addClass, getParentWithClass, hasClass, removeClass } from '@/support/Html';
import { Component, Vue, Prop } from 'vue-property-decorator';
let SubjectHeader = class SubjectHeader extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    hideFullDescription(event, closeClick = false) {
        const target = event.target;
        let popout;
        if (closeClick) {
            popout = getParentWithClass(target, 'subject-header__content--popout');
        }
        else {
            popout = target.querySelectorAll('.subject-header__content--popout')[0];
        }
        if (popout !== null) {
            removeClass(popout, 'show');
        }
    }
    showFullDescription(event) {
        const target = event.target;
        if (hasClass(target, 'subject-header__content--popout')) {
            return;
        }
        const td = target;
        const popout = target.querySelectorAll('.subject-header__content--popout')[0];
        addClass(popout, 'show');
    }
    onOpenSubjectDialogButtonClick() {
        this.$emit('openSubjectDialog');
    }
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods (api calls only
    // #endregion
    // #region Getters & Setters
    get subjectName() {
        return this.subject.name || '';
    }
    get subjectParentName() {
        return this.subject.parent
            && this.subject.parent
            && typeof this.subject.parent !== 'string'
            && this.subject.parent.name
            ? this.subject.parent.name
            : '';
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], SubjectHeader.prototype, "subject", void 0);
SubjectHeader = __decorate([
    Component({})
], SubjectHeader);
export default SubjectHeader;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
